'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var buffer = require('buffer');

/**
 * Serializes an array of boolean into a Buffer. The `byteSize` parameter
 * can be used to create a fixed-size Buffer, otherwise the Buffer will
 * have the minimum amount of bytes required to store the boolean array.
 *
 * Returns a Buffer whose bits are ordered from left to right, unless
 * `backward` is set to true, in which case the bits are ordered from
 * right to left.
 */
const serializeFeatureFlags = (features, byteSize, backward = false) => {
  byteSize = byteSize ?? Math.ceil(features.length / 8);
  const bytes = [];
  for (let i = 0; i < byteSize; i++) {
    let byte = 0;
    for (let j = 0; j < 8; j++) {
      const feature = Number(features[i * 8 + j] ?? 0);
      byte |= feature << (backward ? j : 7 - j);
    }
    if (backward) {
      bytes.unshift(byte);
    } else {
      bytes.push(byte);
    }
  }
  return buffer.Buffer.from(bytes);
};

/**
 * Parses a Buffer into an array of booleans using the
 * bits of the buffer. The number of flags can be provided
 * to determine how many booleans to return.
 *
 * Expects the bits in the Buffer to be ordered from left to right,
 * unless `backward` is set to true, we expect the bits to be
 * ordered from right to left.
 */
const deserializeFeatureFlags = (buffer, numberOfFlags, backward = false) => {
  const booleans = [];
  buffer = backward ? buffer.reverse() : buffer;
  for (let byte of buffer) {
    for (let i = 0; i < 8; i++) {
      if (backward) {
        booleans.push(Boolean(byte & 1));
        byte >>= 1;
      } else {
        booleans.push(Boolean(byte & 0b1000_0000));
        byte <<= 1;
      }
    }
  }
  return booleans.slice(0, numberOfFlags);
};

exports.deserializeFeatureFlags = deserializeFeatureFlags;
exports.serializeFeatureFlags = serializeFeatureFlags;
//# sourceMappingURL=FeatureFlags.cjs.map
